<template>
  <div class="container-fluid">
    <div class="w-100 float-left">
      <ol class="breadcrumb">
        <li v-if="show && ready && showName(crumb)"
            v-for="(crumb, index) in crumbs"
            :key="`breadcrumb-item-${index}`"
            class="breadcrumb-item">

          <span class="active" v-if="index === crumbs.length - 1">
            {{ showName(crumb) | truncate(60) }}
          </span>

          <router-link v-else :to="crumb.route || '#'">
            {{ showName(crumb) | truncate(60) }}
          </router-link>
        </li>
      </ol>

      <div class="float-right back-div">
        <router-link v-if="backRoute && !isCalendar" :to="backRoute">
          <i class="fa fa-chevron-circle-left"></i>&nbsp;
          Voltar
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { get, set, forEach } from 'lodash'
import entities from '@/_entities'
import { resolveHTTP } from '@/services/api'

export default {
  name: 'core-breadcrumb',

  data () {
    return {
      show: true,
      ready: true,
      crumbs: [],
      locks: {},
      isCalendar: false
    }
  },

  watch: {
    '$route' () {
      this.getCrumbs()
    },

    locks: {
      handler (nextLocks) {
        let ready = true
        forEach(nextLocks, (value, key) => {
          ready = ready && value
        })

        this.ready = ready
      },
      deep: true
    }
  },

  computed: {
    backRoute () {
      const backRoute = get(this.$route, 'meta.back', null)

      set(backRoute, 'params', this.$route.params)

      return backRoute
    }
  },

  methods: {
    isLast (index) {
      return index === this.crumbs.length - 1
    },

    showName (crumb) {
      crumb = crumb.label || ''
      return crumb
    },

    getEntity (route) {
      if (route.params) {
        if (route.meta && route.meta.entity === false) {
          return null
        }

        if (route.meta && route.meta.nested) {
          return entities[route.params.nestedEntity] || null
        }

        return entities[route.params.entity] || null
      }

      return null
    },

    getInstanceId (route) {
      if (route.params) {
        if (route.meta && route.meta.nested) {
          return route.params.nestedId
        }

        return route.params.id
      }

      return 0
    },

    hasInstance (route) {
      return this.getInstanceId(route) > 0
    },

    getCrumbs () {
      const self = this
      self.crumbs = []

      function crawlEntity (entity, entityId, index) {
        index = index || 0

        if (entity) {
          if (entityId > 0) {
            // Calls for the api to ge the element
            self.crumbs.splice(index, 0, {
              key: entity.key,
              id: parseInt(entityId, 10),
              label: `#${entityId}`
            })

            self.show = false
            self.$set(self.locks, entity.key + entityId, false)
            const entityHTTP = resolveHTTP(entity.url)

            entityHTTP.show(entityId).then((res) => {
              const index = self.crumbs.findIndex((o) => {
                return (parseInt(o.id, 10) === parseInt(entityId, 10)) && (o.key === entity.key)
              })

              self.crumbs[index] = {
                key: entity.key,
                id: parseInt(entityId, 10),
                label: res.data.name || res.data.title || res.data.slug || `#${res.data.id}`,
                route: {
                  name: `manageables${entity.nested ? '.nested' : ''}.edit`,
                  params: {
                    entity: entity.nested ? entity.parent : entity.key,
                    id: entity.nested ? res.data[entity.parentKey] : entityId,
                    nestedEntity: entity.nested ? entity.key : null,
                    nestedId: entity.nested ? entityId : null
                  }
                }
              }

              if (entity.nested && entity.parent && entity.parentKey) {
                crawlEntity(entities[entity.parent], res.data[entity.parentKey], index)
              } else {
                if (!entity.singlePage) {
                  self.crumbs.splice(index, 0, {
                    label: entity.name || entity.key,
                    route: {
                      name: 'manageables.index',
                      params: {
                        entity: entity.key
                      }
                    }
                  })
                }
              }

              self.$nextTick(() => {
                self.$set(self.locks, entity.key + entityId, true)
                self.show = true
              })
            })
          } else {
            if (self.$route.meta && self.$route.meta.label) {
              self.crumbs.splice(index || 0, 0, {
                label: self.$route.meta.label
              })
            }

            if (entity.nested && entity.parent && self.$route.params.id) {
              crawlEntity(entities[entity.parent], self.$route.params.id, index)
            } else {
              if (!entity.singlePage) {
                self.crumbs.splice(index, 0, {
                  label: entity.name || entity.key,
                  route: {
                    name: 'manageables.index',
                    params: {
                      entity: entity.key
                    }
                  }
                })
              }
            }
            // Tries to resolve the parent ..(as id does not have the entity)
          }
        }
      }

      const entity = self.getEntity(self.$route)
      const entityId = self.getInstanceId(self.$route)
      if (entity) {
        crawlEntity(entity, entityId)
      }

      // The last step is to add a "Home" point that will be the first of the matched route
      if (self.$route.matched.length) {
        const firstRoute = self.$route.matched[0]

        self.crumbs.unshift({
          label: firstRoute.meta && firstRoute.meta.label ? firstRoute.meta.label : 'Início',
          route: firstRoute
        })
      }
      if (window.location.hash === '#/bdm-calendar/new') {
        self.isCalendar = true
      } else {
        self.isCalendar = false
      }
    }
  },

  mounted () {
    this.getCrumbs()
  }
}
</script>

<style lang="sass">
  .back-div a
    color: #96a1af;
    font-size: 12px;
    font-weight: bold;
</style>



// WEBPACK FOOTER //
// src/components/core/Breadcrumb.vue